import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from '../gsap-club/gsap-business-green/src/CustomEase';
gsap.registerPlugin( ScrollTrigger, CustomEase );

/* eslint-disable */
( function () {
	const heroHome = document.querySelector( '.hero-home' );

	if ( heroHome ) {
		const tl = gsap.timeline( { paused: true } );
		const progress = tl.progress;
		const wrap = heroHome.querySelector( '.hero-home__inner' );
		const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-px'), 10); // Get header height from CSS variable

		tl.to(wrap, {
			duration: 0.1,
			y: -300,
			delay: 0.02,
			autoAlpha: 1,
		});

		// create the ScrollTrigger instance
		const trigger = ScrollTrigger.create( {
			animation: tl,
			trigger: heroHome,
			start: 'top-=${headerHeight}px top',
			end: `calc(+=100% - ${headerHeight}px)`, // Subtract header height using template literal
			scrub: 0.1,
			pinSpacing: false,
			pin: true,
			onUpdate: (self) => {
				const scrollPercentage = self.progress * 100;
				if (stateMachineLoadInput) { // Check if stateMachineLoadInput is defined
					stateMachineLoadInput.value = scrollPercentage;
				}
			}
		} );

		let stateMachineLoadInput;
		const scrollAnimation = new rive.Rive({
			src: "/wp-content/themes/mx-corp/assets/images/mx_website_scroll_v3.riv",
			canvas: document.getElementById( 'hero-canvas' ),
			stateMachines: 'state_machine_scroll',
			autoplay: true,

			onLoad: () => {
				const inputs = scrollAnimation.stateMachineInputs('state_machine_scroll');
				if (inputs && inputs.length > 1) { // Check if inputs exist and have at least 2 elements
					stateMachineLoadInput = inputs[0];
					stateMachineLoadInput.value = 1;
					scrollAnimation.resizeDrawingSurfaceToCanvas();
				} else {
					console.error('Invalid state machine inputs.');
				}
			}
		});
	}
} )();
/* eslint-enable */
